export const DefaultNullValue = "¯\\_(ツ)_/¯";
